var React = require('react');

function CollectionsInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1.36133 13.75V22.75C1.36133 23.9926 3.87973 25 6.98633 25C10.0929 25 12.6113 23.9926 12.6113 22.75V13.75","stroke":"#342917","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M14.1113 2.875V22.7308C14.1113 23.984 16.6297 25 19.7363 25C22.8429 25 25.3613 23.984 25.3613 22.7308V2.87501","stroke":"#342917","strokeWidth":"2","key":1}),React.createElement("ellipse",{"cx":"6.98633","cy":"13.75","rx":"5.625","ry":"2.25","stroke":"#342917","strokeWidth":"2","key":2}),React.createElement("ellipse",{"cx":"19.7363","cy":"3.25","rx":"5.625","ry":"2.25","stroke":"#342917","strokeWidth":"2","key":3})]);
}

CollectionsInline.defaultProps = {"width":"27","height":"26","viewBox":"0 0 27 26","fill":"none"};

module.exports = CollectionsInline;

CollectionsInline.default = CollectionsInline;
